// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"a442e9ee","71":"7bd5a12d","121":"cff3b0bd","199":"0dee19f2","456":"9abac47c","637":"24dfb2cb","759":"6b8692b0","787":"ce36f35f"}[chunkId] + ".chunk.css";
};